export const groupBasicAttributes = `
  name
  slug
  public
  found
  archivedAt
  image {
    filename
  }
  verified
  permissions {
    accessible
    createEvent
    createPost
    uploadImage
    editable
    joined
  }
`;
